import { render, staticRenderFns } from "./ListAnnotationsBy.vue?vue&type=template&id=76f4d530&scoped=true"
import script from "./ListAnnotationsBy.vue?vue&type=script&lang=js"
export * from "./ListAnnotationsBy.vue?vue&type=script&lang=js"
import style0 from "./ListAnnotationsBy.vue?vue&type=style&index=0&id=76f4d530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f4d530",
  null
  
)

export default component.exports